import mapProduct from '@/util/mapProduct';
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_PRODUCT_DETAIL_QUERY } from './product.gql';

export const useGetProduct = ({ originalUrlKey, skip }: { originalUrlKey: string; skip: boolean }) => {
  const { loading: productConfigLoading, data } = useQuery(GET_PRODUCT_DETAIL_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: skip,
    variables: {
      urlKey: originalUrlKey,
    },
    onCompleted: async ({ products }) => {
      // try {
      //   const productFind = products.items.find((item:any) => item.url_key === originalUrlKey)

      //   if (!productFind) {
      //     return null
      //   }

      //   const product = mapProduct(productFind)

      //   const productPrice = product?.price_range?.maximum_price

      //   await fetch("/api/pinterest-page-visit", {
      //     method: "POST",
      //     body: JSON.stringify({
      //       product,
      //       productPrice,
      //       ip: currentIp
      //     }),
      //   });
      // } catch (err) {
      //   console.error("Pinterest conversion error:", err);
      // }

      try {
        const productFind = products.items.find((item: any) => item.url_key === originalUrlKey);

        if (!productFind) {
          return null;
        }

        const product = mapProduct(productFind);

        const productPrice = product?.price_range?.maximum_price;

        if (product) {
          window.dataLayer &&
            window.dataLayer.push({
              ecommerce: null,
            });
          window.dataLayer &&
            window.dataLayer.push({
              event: 'view_item',
              ecommerce: {
                currency: productPrice?.final_price.currency,
                value: productPrice?.final_price.value,
                items: [
                  {
                    item_name: product?.name,
                    item_id: product?.sku,
                    price: productPrice?.final_price.value,
                    quantity: 1,
                  },
                ],
              },
            });

          window.pintrk &&
            window.pintrk('track', 'pagevisit', {
              line_items: [
                {
                  product_name: product?.name,
                  product_id: product?.uid,
                  product_category: null,
                  product_price: productPrice?.final_price.value,
                  product_brand: 'hisea',
                },
              ],
            });

          window.fbq &&
            window.fbq('track', 'ViewContent', {
              content_ids: [product.sku],
              content_category: null,
              content_name: product.name,
              content_type: 'product',
              contents: [
                {
                  product_name: product.name,
                  product_id: product.uid,
                  product_category: null,
                  product_price: productPrice?.final_price.value,
                  product_brand: 'hisea',
                },
              ],
              currency: productPrice?.final_price.value,
              value: productPrice?.final_price.value,
            });
        }
      } catch (err) {
        console.error(err);
      }
    },
  });

  const product = useMemo(() => {
    if (!data) {
      // The product isn't in the cache and we don't have a response from GraphQL yet.
      return null;
    }

    // Note: if a product is out of stock _and_ the backend specifies not to
    // display OOS items, the items array will be empty.

    // Only return the product that we queried for.
    const product = data.products.items.find((item: any) => item.url_key === originalUrlKey);

    if (!product) {
      return null;
    }

    return mapProduct(product);
  }, [data, originalUrlKey]);

  const features = useMemo(() => {
    const { products } = data || {};

    const { items } = products || {};

    const { features } = items?.[0] || {};

    return features;
  }, [data]);

  return {
    loading: productConfigLoading,
    product,
    features,
  };
};
